export default __webpack_public_path__ + "static/media/JUNO.2ef21d3a.svg";